import { SubSection } from "context/BlogContext";
import * as Yup from "yup";

export interface ProductFormValues {
  title: string;
  slug: string;
}

export const productInitialValues = (subSection: SubSection) => ({
  title: subSection?.title || "",
  slug: subSection?.attrs?.slug || "",
  image: subSection?.attrs?.image || "",
  id: subSection?.attrs?.id || "",
  productTitle: subSection?.attrs?.productTitle || "",
});

export const productValidationSchema = Yup.object({
  slug: Yup.string().required("Slug is required"),
});
